import { useQuery } from 'react-query'
import { KEYS } from '../../constants'
import { getDemoWorkflows } from '../../api/workflows'

export function useDemoWorkflows() {
  return useQuery(KEYS.demoWorkflows, getDemoWorkflows)
}
